var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({class:_vm.type,attrs:{"type":_vm.submit ? 'submit' : 'button'}},'button',_vm.$props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }